document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector<HTMLElement>('header.HeaderComponent');

    if (!header) return;

    function calculateHeaderHeight() {
        if (header) {
            const headerHeight = header.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
            window.header_height = headerHeight;
        }
    }

    calculateHeaderHeight();


    window.addEventListener('resize', calculateHeaderHeight);

    // create a resize observer for tracking the height of the header
    const observer = new ResizeObserver(calculateHeaderHeight);
    observer.observe(header);

});
